import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AuthService } from '../../services/auth.service';
import { VerificationService } from '../../services/verification.service';
import { TdLoadingService } from '@covalent/core';
import { v4 } from 'uuid';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { environment } from '../../../environments/environment';

const ID_SIGNATURE_CHECK_INTERVAL = 6000; // millis
const ID_SIGNATURE_STOP_AFTER = 360000; // millis

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  termsAndLicenceCheckbox = false;
  isIdCardSignProcessing = false;
  private _IdCardSigningProcessStartTime;
  private _checkUserAgreementInterval;

  private _timeout: number;
  private _failCount: number;
  private _idCardVerifyURL: string;

  get idCardVerifyURL(): SafeUrl {
    return this._sanitizer.bypassSecurityTrustUrl(this._idCardVerifyURL);
  }

  constructor(
    private _httpClient: HttpClient,
    private _verificationService: VerificationService,
    private _authService: AuthService,
    private _router: Router,
    private _loadingService: TdLoadingService,
    private _sanitizer: DomSanitizer
  ) {
    this._failCount = 0;
    this._idCardVerifyURL =
      'geoeid-unitool://api.municipal.gov.ge/id/auth/meta?uuid=' + v4();
  }
  ngOnInit(): void {
    this._authService.sessionData.subscribe((res) => {
      if (res && res.userAgreement && res.userAgreement.isVerified) {
        this._router.navigate(['/idea-create']);
      }
    });
  }
  private async _checkStatus(): Promise<void> {
    const { search } = new URL(this._idCardVerifyURL);
    const url = '/api/id/auth/status/verification' + search;

    const res = await this._httpClient
      .get<any>(url)
      .pipe(catchError(() => of(null)))
      .toPromise();

    if (res.data) {
      if (res.data.status === 1) {
        // window.location.reload();
        return;
      }
    } else {
      this._failCount++;

      if (this._failCount === 40) {
        this._failCount = 0;
        return;
      }
    }

    window.clearTimeout(this._timeout);
    this._timeout = window.setTimeout(this._checkStatus.bind(this), 3000);
  }

  logout() {
    this._loadingService.register();
    this._authService
      .logout()
      .finally(() => {
        this._loadingService.register();
      })
      .subscribe(() => {
        this._router.navigate(['/home']).then(() => location.reload());
      });
  }

  startIdCardSigningProcessing() {
    this._openGeoEIDUniTool();
    // this._startCheckingUserAgreementInterval();
    this._checkStatus();
  }

  private _startCheckingUserAgreementInterval() {
    this._IdCardSigningProcessStartTime = new Date().getTime();

    this._checkUserAgreementInterval = setInterval(() => {
      this._verificationService.checkUserAgreement().subscribe((res: any) => {
        this._authService._setSessionData(JSON.stringify(res.result.data));
        if (localStorage.getItem('sessionData')['userAgreement'].isVerified) {
          this.clearUserAgreementCheckInterval();
          this.logout();
          // this._router.navigate(['']);
        }
      });

      // if the process time lasts more than a certain time, cancel processing
      if (
        this._IdCardSigningProcessStartTime + ID_SIGNATURE_STOP_AFTER <=
        new Date().getTime()
      ) {
        this.clearUserAgreementCheckInterval();
      }
    }, ID_SIGNATURE_CHECK_INTERVAL);
  }

  clearUserAgreementCheckInterval() {
    this.isIdCardSignProcessing = false;
    this.termsAndLicenceCheckbox = false;
    clearInterval(this._checkUserAgreementInterval);
  }

  private _openGeoEIDUniTool() {
    this.isIdCardSignProcessing = true;
    window.location.assign(this._idCardVerifyURL);
  }
  redirectToSsoVerifyUser(): void {
    const url = `${this.ssoUrl}/public/verification/id?redirectUrl=${document.location.href}`;
    const a = document.createElement('a');
    a.href = url;
    a.click();
  }
  get ssoUrl(): string {
    return environment.ssoUrl;
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/profile/profile.component.ts